import { render, staticRenderFns } from "./BarcodePrintOld.vue?vue&type=template&id=0fbcfc42"
import script from "./BarcodePrintOld.vue?vue&type=script&lang=js"
export * from "./BarcodePrintOld.vue?vue&type=script&lang=js"
import style0 from "./BarcodePrintOld.vue?vue&type=style&index=0&id=0fbcfc42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports